const routes = {
  index: {
    path: 'index.consult.list',
    url: '/list',
  },
  home: {
    path: 'index.consult.list.home',
    url: '/accueil',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/list/routes.js